import { render } from "./Tongue.vue?vue&type=template&id=38a8ff6e"
import script from "./Tongue.vue?vue&type=script&lang=js"
export * from "./Tongue.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__